import { GroupTherapyClientsQuery } from "@/graphql/generated";
import { useParams } from "react-router-dom";
import { useGroupTherapyClients } from "./use-group-therapy-clients-overview/use-group-therapy-clients-overview.api";

interface UseGroupTherapyClientsPageParams<T> {
  select: (data: GroupTherapyClientsQuery) => T;
}

export const useGroupTherapyClientsPage = <T extends object>({
  select,
}: UseGroupTherapyClientsPageParams<T>) => {
  const { groupId } = useParams<{ groupId: string }>();

  const enabled = !!groupId;

  const { data, isLoading } = useGroupTherapyClients({
    enabled,
    groupId,
    select: (data) => select(data),
  });

  return { data, isLoading };
};
